import { getGoToBrandReferralsCTA } from "./shared";
export var BrandReferralHowToReferBrandIA = function BrandReferralHowToReferBrandIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return BRAND_REFERRALS_REFER_A_BRAND_TITLE(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [BRAND_REFERRALS_REFER_A_BRAND_DESCRIPTION(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getGoToBrandReferral;
        return (_getGoToBrandReferral = getGoToBrandReferralsCTA(context, strictLocalize)) === null || _getGoToBrandReferral === void 0 ? void 0 : _getGoToBrandReferral.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getGoToBrandReferral2, _getGoToBrandReferral3;
        return (_getGoToBrandReferral2 = getGoToBrandReferralsCTA(context, strictLocalize)) === null || _getGoToBrandReferral2 === void 0 ? void 0 : (_getGoToBrandReferral3 = _getGoToBrandReferral2.getLink) === null || _getGoToBrandReferral3 === void 0 ? void 0 : _getGoToBrandReferral3.call(_getGoToBrandReferral2);
      }
    }
  };
};
var BRAND_REFERRALS_REFER_A_BRAND_TITLE = function BRAND_REFERRALS_REFER_A_BRAND_TITLE(strictLocalize) {
  return strictLocalize({
    id: "1pX4bk",
    defaultMessage: [{
      "type": 0,
      "value": "Como convidar uma marca"
    }]
  });
};
var BRAND_REFERRALS_REFER_A_BRAND_DESCRIPTION = function BRAND_REFERRALS_REFER_A_BRAND_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "i4hHoa",
    defaultMessage: [{
      "type": 0,
      "value": "Para convidar uma marca para vender na Faire, aceda a \"Convidar marcas\" em \"Conta\" e adicione o respetivo e-mail ou site, ou partilhe o link de convite diretamente com a marca."
    }]
  });
};